import React, { PropsWithChildren } from "react";

import { MeetingInfoContext } from "../../../context";
import NoRemoteView from "../video/controls/no-remote-view";

const ErrorOrChildren: React.FC<PropsWithChildren> = ({
    children,
}) => {

    const { connected, errorMessage } = React.useContext(MeetingInfoContext);

    return (
        <>
            {connected && errorMessage === null && children}
            {errorMessage && <NoRemoteView message={errorMessage} backgroundColor='lightGrey' />}
        </>
    );
};

export default ErrorOrChildren;
